"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetTenantFailedError = void 0;
const teamsfx_api_1 = require("@microsoft/teamsfx-api");
const localizeUtils_1 = require("../../../../../common/localizeUtils");
const constants_1 = require("../utility/constants");
const errorCode = "GetTenantFailed";
const messageKey = "plugins.spfx.GetTenantFailedError";
class GetTenantFailedError extends teamsfx_api_1.SystemError {
    constructor(username, error) {
        super({
            source: constants_1.Constants.DeployDriverName,
            name: errorCode,
        });
        // TODO: move strings to the localization file
        const param1 = username ? `for user ${username} ` : "";
        const param2 = error ? `due to error ${error.message}` : "";
        this.message = (0, localizeUtils_1.getDefaultString)(messageKey, param1, param2);
        this.displayMessage = (0, localizeUtils_1.getLocalizedString)(messageKey, param1, param2);
    }
}
exports.GetTenantFailedError = GetTenantFailedError;
//# sourceMappingURL=getTenantFailedError.js.map